import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './JNJFooter.module.scss'
import logo from '../../assets/J&J New Logo.png'

const SMALL_SCREEN_RES = 413
const MED_SCREEN_RES = 900

function calculateSize() {
  const screenWidth = window.innerWidth

  if (screenWidth <= SMALL_SCREEN_RES) {
    return 'small'
  }

  if (screenWidth <= MED_SCREEN_RES) {
    return 'medium'
  }

  return 'large'
}

export default function JNJFooter(props) {
  const [footerSize, setFooterSize] = useState(calculateSize())
  const { t } = useTranslation()

  useEffect(() => {
    function handleResize() {
      setFooterSize(calculateSize())
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div data-testid={`jnj-footer-${footerSize}`} className={styles[`footer-wrapper-${footerSize}`]}>
      <p className={`${styles['footer-text']} ${styles[`footer-text-${footerSize}`]}`}>{t('FooterText')}</p>
      <img className={styles[`footer-image-${footerSize}`]} src={logo} alt={props.imageAlt} />
    </div>
  )
}

JNJFooter.propTypes = {
  imageAlt: PropTypes.string,
}

JNJFooter.defaultProps = {
  imageAlt: 'JnJ Logo',
}
